import React from 'react';
import styles from './styles.module.scss';
import icCloseIcon from 'assets/svg/ic_close.svg';
import ThetanButton from '@profile/src/Components/ThetanButton';
import Modal from '@profile/src/Components/Modal';

const ClaimBoxSuccessModal = ({
  onClose,
  data
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: styles.close
  }, /*#__PURE__*/React.createElement("img", {
    src: icCloseIcon
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, /*#__PURE__*/React.createElement("span", null, "CONGRATULATION!")), /*#__PURE__*/React.createElement("span", {
    className: styles.subTitle
  }, "You got"), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapperBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bg
  }), /*#__PURE__*/React.createElement("img", {
    src: data.imgPath,
    className: styles.img
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.boxName
  }, data.name, " box"))), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(ThetanButton, {
    onClick: () => {
      onClose();
      location.reload();
    },
    className: styles.btn,
    title: "Claim"
  }))));
};

export default ClaimBoxSuccessModal;